const ARCHIVE_TYPE = {
  FOLDER: 'FOLDER',
  CONTACT_LIST: 'CONTACT_LIST',
};

export { ARCHIVE_TYPE };
